import { refreshIcons } from "@/ui/dom";
import { initEvents } from "@/ui/events";
import { initNavigation, onViewChange } from "@/ui/navigation";
import {
  renderBookServices,
  renderContactos,
  renderInitial,
  renderReservas,
  renderServices,
} from "@/ui/rendering";
import type { ViewId } from "@/types";

/** Refresca los datos propios de cada vista al navegar hacia ella. */
function renderForView(view: ViewId): void {
  switch (view) {
    case "servicios":
      renderServices();
      break;
    case "reservar":
      renderBookServices();
      break;
    case "agenda":
      renderReservas();
      break;
    case "contactos":
      renderContactos();
      break;
    default:
      break;
  }
}

/** Arranque de la aplicación: render inicial, eventos y navegación. */
export function startApp(): void {
  renderInitial();
  initEvents();
  onViewChange(renderForView);
  initNavigation();
  refreshIcons();
}
